
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import { useTheme } from "@/contexts/ThemeContext";

export const BackButton = () => {
  const { colors } = useTheme();
  
  const handleBack = () => {
    window.history.back();
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      className="mb-8 inline-block"
    >
      <Button
        variant="ghost"
        size="icon"
        onClick={handleBack}
        className="border transition-all duration-300 hover:scale-105"
        style={{
          color: colors.foreground,
          borderColor: `${colors.border}60`,
          backgroundColor: `${colors.card}90`,
          backdropFilter: 'blur(10px)'
        }}
      >
        <ArrowLeft size={20} />
      </Button>
    </motion.div>
  );
};
